(function() {
	angular
		.module('main')
		.controller('LeadSourcesSettingsController', LeadSourcesSettingsController);

	LeadSourcesSettingsController.$inject = [
		'$scope',
		'$location',
		'settingsService'
	];

	function LeadSourcesSettingsController($scope, $location, settingsService) {
		$scope.$on('$viewContentLoaded', () => {
			settingsService.timeFormatSettings.subscribe(data => {
				if (data.leadSourcesAvailable === false) {
					$location.url('/');
				}
			});
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/leadSourcesSettingsController.js